import { useLoaderData } from 'react-router';
import { getLocale } from '~/lib/languages';
import { LEGAL_DOCS } from '~/content/legal/manifest';
import { LegalLayout } from '~/components/legal/legal-layout';
import { LegalProse } from '~/components/legal/legal-prose';
import type { Route } from './+types/document';

export async function loader({ params, request }: Route.LoaderArgs) {
  const type = params.type;
  if (type !== 'terms' && type !== 'privacy') {
    throw new Response(null, { status: 404 });
  }

  const section = LEGAL_DOCS[type];
  const version = params.version ?? 'current';

  if (!Object.hasOwn(section.docs, version)) {
    throw new Response(null, { status: 404 });
  }

  const doc = section.docs[version as keyof typeof section.docs];
  const locale = await getLocale(request);
  const lang = locale === 'ja' ? 'ja' : 'en';

  return {
    type,
    version,
    versions: section.versions,
    locale: lang,
    content: doc.content[lang],
  };
}

export function meta({ data }: Route.MetaArgs) {
  const titleMap: Record<string, string> = {
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
  };
  const title = data ? (titleMap[data.type] ?? 'Legal') : 'Legal';
  return [{ title: `${title} | Startable` }];
}

export default function LegalDocument() {
  const { content } = useLoaderData<typeof loader>();

  return (
    <LegalLayout>
      <LegalProse content={content} />
    </LegalLayout>
  );
}
